import React, { useState } from 'react';
import '../Assets/Css/AddTaskModal.scss';
import { Modal, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import closeIcon from '../Assets/Images/Pop-Up/Close_button.svg'


function AddTaskCategoryModal({ isOpen, onClose, addTaskCategory, taskCategory, loading, deleteTaskCategory, deleteLoading }) {

  const [newCategory, setNewCategory] = useState('');

  const handleDelete = async (id) => {
    try {
      await deleteTaskCategory(id);
    } catch (error) {

    }
  };

  const handleAddCategory = async () => {
    try {
      if (!newCategory) {
        toast.error("Please enter a category name");
        return;
      }
      await addTaskCategory({ category_name: newCategory });
      setNewCategory('');
    } catch (error) {
      console.error("Error in adding task category:", error);
    }

  };

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="custom-modal"
    >
      <div className="modal-content">
        <div className="modal-header">
          <h5>Task Category</h5>
          <button className="close-btn" onClick={onClose}>
            {<img src={closeIcon} alt="Close" />}
          </button>
        </div>
        <div className="modal-body">
          <table className="category-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Category Name</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {taskCategory?.map((category) => (
                <tr key={category.id}>
                  <td>{category.id}</td>
                  <td>{category.category_name}</td>
                  <td>
                    <button onClick={() => handleDelete(category.id)}>
                      {deleteLoading ? (<Spinner as="span" animation="border" role="status" aria-hidden="true" />) : "Delete"}</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="category-form">
            <label>Catagory Name <span style={{ color: 'red' }}>*</span></label>
            <input
              type="text"
              placeholder="Enter a category name"
              value={newCategory}
              onChange={(e) => setNewCategory(e.target.value)}
            />
          </div>
        </div>
        <div className="modal-footer">
          <button className="save-btn" onClick={onClose}>
            Close
          </button>
          <button className="save-btn" onClick={handleAddCategory}>
            {loading ? (<Spinner as="span" animation="border" role="status" aria-hidden="true" />) : "Save"}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default AddTaskCategoryModal;
